import { put } from 'redux-saga/effects';
import {
  getApplicationFormBySeason,
  getFieldOptionById,
} from '../../api/applicationFormQuestionAPI';
import * as types from './formStructureActionTypes';

// helpers
import { generateId } from '../../helpers/utils';

export function* formStructureSaga({ seasonId, countrySfId }) {
  try {
    const form = yield getApplicationFormBySeason(seasonId, countrySfId);
    if (form && form.error) {
      yield put({
        type: types.GET_FORM_ERROR,
        error: form.error,
      });
    } else {
      yield put({
        type: types.GET_FORM_SUCCESS,
        form,
      });
      const optionByField = {};
      const fieldIdForOptions = form
        .filter(field => field.fieldTypeC === 'Picklist')
        .map(field => field.sfId);
      for (let i = 0; i < fieldIdForOptions.length; i++) {
        const options = yield getFieldOptionById(fieldIdForOptions[i]);
        optionByField[fieldIdForOptions[i]] = options.map(option => ({
          key: generateId(),
          text: option.name,
          value: option.name,
        }));
      }
      yield put({
        type: types.SET_OPTIONS_BY_FIELDS,
        optionByField,
      });
    }
  } catch (error) {
    yield put({
      type: types.GET_FORM_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// ./src/store/formStructure/formStructureSaga.js